import React from 'react'
import ProgressBar from './Mui/CustomProgressBar'
import AudioPlayer from './Mui/AudioPlayer'
import CustomOutlinedButton from './Mui/CustomOutlinedButton';
import { Control } from 'react-redux-form'
import Typography from '@material-ui/core/Typography';

class AudioSubForm extends React.PureComponent {
  render() {
    const {
      progress, tempduration,
      audio, audioReady, audioValid, audioFile,
      handleDeleteAudio, handleUploadAudio
    } = this.props

    return (
      <div className="pl-24 pr-24 pb-24">
<ProgressBar />
           
          {
            progress === 0 && audio === null && (
             <React.Fragment>
               <Typography className="h6 mb-8">Audio File</Typography> 
               <Typography className="caption mb-16">(file must be in MP3 or WAV format, max file size 6MB)</Typography>   
               <CustomOutlinedButton
                 className="buttonnoto c-blue align-self-center mr-16"
                 onClick={e=>{
                   document.getElementById('question-audio').click()
               }}>UPLOAD AUDIO</CustomOutlinedButton>
               <span
                className={`TextInput-error ${audioValid ? 'd-none' : ''}`}
                style={{fontSize: 12}}>
                 Audio file is required
               </span>
             </React.Fragment>
           )
          }
          {
            audio !== null && audioReady &&
            (
              <AudioPlayer
                source={audio}
                filename={audioFile}
                tempduration={tempduration}
                showDelete={true}
                handleDelete={handleDeleteAudio}
              />
            )
          }

          <Control.file
            id="question-audio"
            model="wave"
            changeAction={handleUploadAudio}
            accept=".mp3,.wav"
            className="d-none"
          />
      </div>
    )
  }
}

export default AudioSubForm



// WEBPACK FOOTER //
// ./src/js/components/AudioSubForm.js